import Authentication from 'client/services/Authentication';
import Sidebar from 'client/services/Sidebar';
import { throttle } from 'underscore';


var services = angular.module('myp.services',['ngResource','ngSanitize']);

// Function used to execute waiting
function wait(ms){
    var start = new Date().getTime();
    var end = start;

    while(end < start + ms)
        end = new Date().getTime();
}

/* used to setup the Google Map for the webpage and all the options */
services.factory('googleMapsFactory', function(){
    return{
      loadMap : function () {
          //Create object to hold the styling for the Google Map
          var mapStyles = [
              {
                  featureType: "poi.business",
                  stylers:[
                      {visibility: "off"}
                  ]
              }
          ];

          //Create object to hold Google Map options
          var mapOptions = {
              zoom:10,
              center: new google.maps.LatLng(43.988461,-79.470389),
              panControl: false,
              styles: mapStyles,
              zoomControlOptions: {
                  style: google.maps.ZoomControlStyle.DEFAULT,
                  position: google.maps.ControlPosition.RIGHT_TOP
              },
              mapTypeId: google.maps.MapTypeId.ROADMAP,
              mapTypeControlOptions: {
                  style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                  position: google.maps.ControlPosition.TOP_RIGHT
              },
              clickableIcons: false,
              controlSize: 24,
              options: {
                gestureHandling: 'greedy',
              },
          };

          //Return the google maps object with the map options set
          return new google.maps.Map(document.getElementById('map-canvas'),mapOptions);
      }
    };

});

/* used for JSON calls to get mapping information for sidebar */
services.factory('Maps',['$resource',
    function ($resource) {
        return $resource('data/:mapId.json',{mapId:'@id'},{
            query:{method:'GET', isArray:true}
        });
    }]);

/* Used to inform users */
services.factory('flashService', function ($rootScope) {
   return{
       show: function(message){
           $rootScope.flash = message;
       },
       clear: function(){
           $rootScope.flash = "";
       }
   }
});

/* Used to authenticate users trying to login */
services.factory('authenticationService', [
  '$resource', '$http', '$location', 'flashService', '$sanitize', '$rootScope',
  Authentication
]);

/* Development application service */
services.factory('datorontoService',['$resource','$http','$location','flashService',
    function($resource,$http,$location,flashService){
        return{
            devappInfo: function(coords){
                var devappInfo = $http.post("/users/datinfo",coords);
                devappInfo.success(function (data){

                });
                return devappInfo;
            },
            devappCount: throttle(function(coords){
                console.log('called throttled devappCount()');
                  var devappCount = $http.post("/users/dev_app_count",coords);
                  devappCount.success(function (data){

                  });
                  return devappCount;
              },
              1000
            ),
            devappFilterOptions: function(){
                var devappFilterOptions = $http.get("/data/datfilteroptions");
                devappFilterOptions.success(function (data){

                });
                return devappFilterOptions;
            },
            disclaimerAccept: function(){
                var disclaimerAccept = $http.get("/users/disclaimer");
                disclaimerAccept.success(function (data){

                });
                return disclaimerAccept;
            },
            disclaimerCheck: function(){
                var disclaimerAccept = $http.get("/users/disclaimer_check");
                disclaimerAccept.success(function (data){

                });
                return disclaimerAccept;
            }

        }

    }]);

/* Used to help remind users */
services.factory('reminderService',['$resource','$http','$location','flashService',
    function ($resource,$http,$location,flashService){
        return{
            sendactivation: function(user){
                var sendactivation = $http.post("/users/sendactivation", user);
                sendactivation.success(function (data){

                });
                return sendactivation;
            }
        }
}]);

/* Used to create new users */
services.factory('registerService',['$resource','$http','$location','flashService',
    function ($resource,$http,$location,flashService) {
        return{
            register: function(user){
                var register = $http.post("/users/register", user);
                register.success(function (data) {

                });
                return register;
            },
            tmpregister: function(user){
                var tmpregister = $http.post("/users/tmpregister", user);
                tmpregister.success(function (data) {

                });
                return tmpregister;
            }
        }
}]);

/* Used to let users reset their passwords when they forget them */
services.factory('resetService',['$resource','$http','$location','flashService',
    function ($resource,$http,$location,flashService) {
        //Send response message to the user
        var resetResponse = function (response) {
            if(response.email)
                flashService.show(response.email[0]);
            else
                flashService.show(response.flash);
        };

        return{
            forgotpassword: function(credentials) {
                var forgotpassword = $http.post('/users/forgotpassword',credentials);
                flashService.clear();
                forgotpassword.success(resetResponse);
                forgotpassword.error(resetResponse);
                return forgotpassword;
            }
        };

}]);

/* Used to capture users property clicks */
services.factory('historyService',['$resource','$http', '$location', 'flashService',
    function ($resource,$http,$location,flashService){
        return {
            savehistory: function (history) {
                var savehistory = $http.post('/auth/savehistory', history);
                savehistory.success(function (data) {

                });
                return savehistory;
            },
            gethistory: function () {
                var gethistory = $http.get('/auth/gethistory');
                gethistory.success(function (data) {

                });
                return gethistory;
            },
            savedevhistory: function (history){
                var savedevhistory = $http.post('/auth/savedevhistory', history);
                savedevhistory.success(function (data){

                });
                return savedevhistory;
            }
        }
}]);

/* Used by admin to generate codes to invite people to signup */
services.factory('adminService',['$resource','$http','$location',
    function($resource,$http,$location){
        return{
            generatecode: function(){
                var generatecode = $http.get('/auth/generatecode');
                return generatecode;
            },
            sendcode: function(inviteCredentials){
                var sendcode = $http.post('/auth/sendcode', inviteCredentials);
                sendcode.success(function () {

                });
                return sendcode;
            },
            sendinvite: function(inviteCredentials){
                var sendinvite = $http.post('/auth/sendinvite', inviteCredentials);
                sendinvite.success(function () {

                });
                return sendinvite;
            },
            isAdmin: function(){
                var isAdmin = $http.get('/auth/adminstatus');
                return isAdmin
            },
            logout: function(){
                var logout = $http.get('/auth/adminout');
                return logout;
            },
            changepass: function(resetCredentials){
                var changepass = $http.post('/auth/changepass', resetCredentials);
                changepass.success(function (data) {
                });
                return changepass;
            }
        }
}]);

/* Used to activate new users */
services.factory('activateService',['$resource','$http','$location',
    function($resource,$http,$location){
        return{
            activate: function (code) {
                var activate = $http.post('/auth/activate',code);
                activate.success(function (data) {

                });
                return activate;
            },
            setpassword: function(password) {
                var setpassword = $http.post('/auth/setpassword', password);
                setpassword.success(function (data) {

                });
                return setpassword;
            }
        }
}]);

/* Used to get information for the sidebar */
services.factory('sidebarService',['$resource','$http','$rootScope','$timeout', Sidebar]);

services.factory('lockService',['$http',
    function($http){
        var reportLockStatus = function(){
            return $http({method:"GET", url:"/users/lock_status"}).then(function(result){
                if(result.data != 0){
                    wait(5000);
                    return reportLockStatus();
                }
                return result.data;
            });
        };

        return {reportLockStatus: reportLockStatus};
}]);

services.factory('reportService',['$resource','$http','$rootScope','$timeout',
    function ($resource, $http, $rootScope, $timeout) {
        return{
            reportInfo: function (report) {
                var reportInfo = $http.post('/users/report_verify', report, {timeout: 60000});
                reportInfo.success(function (data) {

                });
                reportInfo.error(function (data) {

                });
                return reportInfo;
            },
            reportUpdate: function(report){
                var reportUpdate = $http.post('/users/report_update', report);
                reportUpdate.success(function (data){

                });
                reportUpdate.error(function (data){

                });
                return reportUpdate;
            },
            devReportUpdate: function(report){
                var reportUpdate = $http.post('/users/dev_report_update',report);
                reportUpdate.success(function (data){

                });
                reportUpdate.error(function (data){

                });
                return reportUpdate;
            },
            reportRequest: function(report){
                var reportRequest = $http.post('/users/request_report', report);
                reportRequest.success(function (data){

                });
                reportRequest.error(function (data){

                });
                return reportRequest;
            },
            reportDevRequest: function(report){
                var reportDevRequest = $http.post('/users/request_dev_report', report);
                reportDevRequest.success(function (data){

                });
                reportDevRequest.error(function (data){

                });
                return reportDevRequest;
            },
            reportDAT: function(report){
                var reportDAT = $http.post('/users/devrr', report);
                reportDAT.success(function (data){

                });
                reportDAT.error(function (data){

                });
                return reportDAT;
            },
            reportError: function(report){
                var reportError = $http.post('/users/report_error', report);
                reportError.success(function (data) {

                });
                reportError.error(function (data){

                });
                return reportError;
            }
        }
    }]);



// WEBPACK FOOTER //
// ./public/js/services.js